import { BaseFeature, FeatureType } from '@core/shared/feature';
import { QuestionCategoryItem, QuestionItem } from '@pflegetheke/questions/shared';
import { slugify } from '@core/shared/utils';
import { DefaultAbilityAction } from '@core/shared/ability';
export class PflegethekeQuestionsBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@pflegetheke/questions/feature","featureId":"pflegetheke-questions"},
      bundledItemModels: ["QuestionItem", "QuestionTagItem", "QuestionProgressItem", "QuestionHitsItem", "QuestionCategoryItem", "QuestionAttachmentItem"],
      // list is auto-generated by generate-model-ids
      abilityActions: [{
        action: 'Preview',
        defaultBias: 1
      }, {
        action: DefaultAbilityAction.View,
        defaultBias: -1
      }],
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeQuestionsFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeQuestionsFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeQuestionsBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeQuestionsBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    const resolveQuestionCategoryRoute = info => {
      const commands = ['/questions'];
      if (typeof info === 'number') {
        commands.push('' + info);
      } else if (info instanceof QuestionCategoryItem) {
        commands.push(info.id + '-' + slugify(info.name));
      } else if (info instanceof QuestionItem) {
        if (info.category) {
          commands.push(info.category.id + '-' + slugify(info.category.name));
        } else if (info.categoryId) {
          commands.push('' + info.categoryId);
        } else {
          throw new Error('Cannot route a QuestionItem without any information on its category!');
        }
      } else {
        throw new Error('unsupported arg type');
      }
      return commands;
    };
    return {
      routerLinkResolvers: {
        frontend: {
          questionCategories: () => '/questions',
          QuestionCategoryItem: info => {
            if (!info?.category) throw new Error('QuestionCategoryItem link resolver requires a full QuestionCategoryItem to be passed!');
            const question = info.question || info.category.items?.[0] || null;
            const commands = resolveQuestionCategoryRoute(info.category);
            if (question) {
              commands.push(question.id + '-' + slugify(question.name));
            }
            return commands;
          },
          QuestionCategoryFeedback: info => {
            const commands = resolveQuestionCategoryRoute(info);
            commands.push('feedback');
            return commands;
          },
          QuestionItem: info => {
            if (typeof info === 'number') throw new Error('QuestionItem link resolver currently only supports passing a full item!');
            const commands = resolveQuestionCategoryRoute(info);
            const questionSegment = info.id + '-' + slugify(info.name);
            commands.push(questionSegment);
            return commands;
          }
        }
      }
    };
  }
}